<svg
  id="help-info-button"
  class="tw-ml-2 tw-h-{{ size }} tw-w-{{
    size
  }} tw-text-dt-text-tertiary hover:tw-text-dt-text-action {{ class }}"
  [ngClass]="{ '!tw-text-dt-text-action': isClicked }"
>
  <use xlink:href="images/sprite.svg#info-tooltip" />
</svg>
